// Code taken from here
//https://stackoverflow.com/questions/45072369/how-to-restrict-special-characters-in-the-input-field-using-angular2-typescript

/*
Usage example:

<input type="text" appInputRestriction="noSpecialChars" class="form-control-full" [(ngModel)]="noSpecialCharsModel" [ngModelOptions]="{standalone: true}" [disabled]="isSelected" required>

<input type="text" appInputRestriction="integer" class="form-control-full" [(ngModel)]="integerModel" [ngModelOptions]="{standalone: true}">

*/

import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({
    selector: '[appInputRestriction]'
})
export class InputRestrictionDirective {
    inputElement: ElementRef;

    @Input('appInputRestriction') appInputRestriction: string;
    arabicRegex = '[\u0600-\u06FF]';

    constructor(el: ElementRef) {
        this.inputElement = el;
    }

    @HostListener('keypress', ['$event']) onKeyPress(event) {
        if (this.appInputRestriction === 'integer') {
            this.integerOnly(event);
        } else if (this.appInputRestriction === 'twoInteger') {
            this.twoIntegerOnly(event);
        } else if (this.appInputRestriction === 'noSpecialChars') {
            this.noSpecialChars(event);
        } else if (this.appInputRestriction === 'noSpecialCharsAndNumbers') {
            this.noSpecialCharsAndNumbers(event);
        } else if (this.appInputRestriction === 'noSpecialCharsAndNumbersAndAccent') {
            this.noSpecialCharsAndNumbersAndAccent(event);
        } else if (this.appInputRestriction === 'decimal') {
            this.decimal(event);
        } else if (this.appInputRestriction === 'percent') {
            this.percent(event);
        }

    }

    integerOnly(event) {
        const e = <KeyboardEvent>event;
        if (e.key === 'Tab' || e.key === 'TAB') {
            return;
        }

        if ([8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && e.ctrlKey === true) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && e.ctrlKey === true) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && e.ctrlKey === true) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && e.ctrlKey === true)) {
            // let it happen, don't do anything
            return;
        }
        if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].indexOf(e.key) === -1) {
            e.preventDefault();
        }
    }

    percent(event) {
        var currentValue = event.target.value;

        const e = <KeyboardEvent>event;
        if (e.key === 'Tab' || e.key === 'TAB') {
            return;
        }

        if ([8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && e.ctrlKey === true) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && e.ctrlKey === true) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && e.ctrlKey === true) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && e.ctrlKey === true)) {
            // let it happen, don't do anything
            return;
        }

        if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].indexOf(e.key) === -1) {
            e.preventDefault();
        }

        let splittedCurrentValue = currentValue.split('.');

        if ((splittedCurrentValue.length > 1 && splittedCurrentValue[1].length == 2) || (currentValue.length == 3 && currentValue.indexOf('.') < 0) || Number(currentValue + e.key) > 100 || Number(currentValue + e.key) < 1) {
            e.preventDefault();
        }
    }

    decimal(event) {
        const e = <KeyboardEvent>event;
        if (e.key === 'Tab' || e.key === 'TAB') {
            return;
        }

        if (e.key == '0' && (event.target.value == '' || event.target.value == '0')) {
            e.preventDefault();
        }

        if (e.key == ',' && (event.target.value.includes(',') || event.target.value.includes('.') || event.target.value === '' || event.target.value == ',' || event.target.value == ' ')) {
            e.preventDefault();
        }

        if (event.target.value.includes('.') && ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(e.key)) {
            var splittedValue = event.target.value.split('.');
            var afterCommaValue = splittedValue[1];
            if (afterCommaValue.length == 2) {
                e.preventDefault();
            }
        }

        if ([8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && e.ctrlKey === true) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && e.ctrlKey === true) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && e.ctrlKey === true) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && e.ctrlKey === true)) {
            // let it happen, don't do anything
            return;
        }

        if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', ','].indexOf(e.key) === -1) {
            e.preventDefault();
        }
    }

    noSpecialChars(event) {
        const e = <KeyboardEvent>event;
        if (e.key === 'Tab' || e.key === 'TAB') {
            return;
        }
        let k;
        k = event.keyCode;  // k = event.charCode;  (Both can be used)
        if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57) || k === 241) {
            return;
        }
        const ch = String.fromCharCode(e.keyCode);
        const regEx = new RegExp(this.arabicRegex);
        if (regEx.test(ch)) {
            return;
        }
        e.preventDefault();
    }

    noSpecialCharsAndNumbers(event) {
        const e = <KeyboardEvent>event;
        if (e.key === 'Tab' || e.key === 'TAB') {
            return;
        }
        let k;
        k = event.keyCode;  // k = event.charCode;  (Both can be used)
        if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || k === 241) {
            return;
        }

        const ch = String.fromCharCode(e.keyCode);
        const regEx = new RegExp(this.arabicRegex);
        if (regEx.test(ch)) {
            return;
        }

        e.preventDefault();
    }

    noSpecialCharsAndNumbersAndAccent(event) {
        const e = <KeyboardEvent>event;
        if (e.key === 'Tab' || e.key === 'TAB') {
            return;
        }
        let k;
        const lettersWithAccentKeyCodes = [225, 193, 233, 201, 237, 205, 243, 211, 250, 218];

        k = event.keyCode;  // k = event.charCode;  (Both can be used)
        if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || k === 241 || lettersWithAccentKeyCodes.includes(k)) {
            return;
        }

        const ch = String.fromCharCode(e.keyCode);
        const regEx = new RegExp(this.arabicRegex);
        if (regEx.test(ch)) {
            return;
        }

        e.preventDefault();
    }

    twoIntegerOnly(event) {
        var currentValue = event.target.value;
        const e = <KeyboardEvent>event;
        if (e.key === 'Tab' || e.key === 'TAB') {
            return;
        }

        if (
            e.key == '0' &&
            (event.target.value == '' || event.target.value == '0')
        ) {
            e.preventDefault();
        }

        if (currentValue.length == 2) {
            e.preventDefault();
        }

        if (
            [8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && e.ctrlKey === true) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && e.ctrlKey === true) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && e.ctrlKey === true) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && e.ctrlKey === true)
        ) {
            // let it happen, don't do anything
            return;
        }
        if (
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].indexOf(e.key) === -1
        ) {
            e.preventDefault();
        } else {
            if (currentValue.length == 0 && e.key == '0') {
                e.preventDefault();
            }
        }
    }

    @HostListener('paste', ['$event']) onPaste(event) {
        let regex;
        if (this.appInputRestriction === 'integer') {
            regex = /[0-9]/g;
        } else if (this.appInputRestriction === 'twoInteger') {
            regex = /[0-9]/g;
        } else if (this.appInputRestriction === 'noSpecialChars') {
            regex = /[a-zA-Z0-9\u0600-\u06FF]/g;
        } else if (this.appInputRestriction === 'noSpecialCharsAndNumbers') {
            regex = /[a-zA-Z0-9\u0600-\u06FF]/g;
        } else if (this.appInputRestriction === 'decimal') {
            regex = "^\\s*((\\d+(\\.\\d{0," + 2 +
                "})?)|((\\d*(\\.\\d{1," +
                2 +
                "}))))\\s*$";
        }

        const e = <ClipboardEvent>event;
        const pasteData = e.clipboardData.getData('text/plain');
        let m;
        let matches = 0;
        while ((m = regex.exec(pasteData)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            // The result can be accessed through the `m`-variable.
            m.forEach((match, groupIndex) => {
                matches++;
            });
        }
        if (matches === pasteData.length) {
            return;
        } else {
            e.preventDefault();
        }
    }



}